// This demo shows how to place windows by hand; the text above tells you to.
// biome-ignore-all lint/plugin/no-inline-layout-style: inline placement is the subject
import { BeWindow } from "@beos-css/react/index.ts";

export function MultipleWindowsDemo() {
	return (
		<section id="demo-multiple-windows">
			<h2>Multiple windows (a desktop)</h2>
			<p>
				Several <code>BeWindow</code>s positioned on a desktop and overlapping: the front one is active (yellow), the ones behind are{" "}
				<code>inactive</code> (grey). Pass <code>style</code> with position/top/left to place them.
			</p>
			<div
				style={{
					position: "relative",
					height: 320,
					background: "#5a7a9a",
					padding: 0,
					overflow: "hidden",
				}}
			>
				<BeWindow
					inactive
					title="Tracker"
					onClose={() => {}}
					onZoom={() => {}}
					style={{ position: "absolute", top: 30, left: 24 }}
					contentStyle={{ width: 240, height: 150 }}
				>
					A window behind the active one.
				</BeWindow>
				<BeWindow
					inactive
					title="Notes"
					onClose={() => {}}
					onZoom={() => {}}
					style={{ position: "absolute", top: 70, left: 200 }}
					contentStyle={{ width: 220, height: 140 }}
				>
					Another background window.
				</BeWindow>
				<BeWindow
					title="StyledEdit"
					onClose={() => {}}
					onZoom={() => {}}
					style={{ position: "absolute", top: 120, left: 120 }}
					contentStyle={{ width: 260, height: 150 }}
				>
					The active (front) window -- yellow tab.
				</BeWindow>
			</div>
		</section>
	);
}
